import {
  default as ExhibitionistBox,
  ExhibitionistBoxProps as ImportedProps,
} from './ExhibitionistBox';
export { ExhibitionistBoxType } from './ExhibitionistBox';
export type ExhibitionistBoxProps = ImportedProps;
import { withFeatureBranch } from '@wix/da-shared-react/pkg/redux/flags';
import ExhibitionistBox__premium_folders from '../ExhibitionistBox__premium_folders';

export default withFeatureBranch({
  premium_folders: ExhibitionistBox__premium_folders,
})(ExhibitionistBox);
